import Box from '@zenbusiness/zui/Box';
import PropTypes from 'prop-types';

import FormModal from '#client/components/FormModal';
import { FocusGrid, ContainerGrid, PageFocusItem } from '#client/components/Grid';

import CheckDepositContainer from './components/CheckDepositContainer';

export default function CheckDepositHistory({ handleClose }) {
  return (
    <FormModal handleClose={handleClose}>
      <Box
        height="100%"
        width="100%"
      >
        <ContainerGrid height="100%">
          <FocusGrid height="100%">
            <PageFocusItem height="100%">
              <CheckDepositContainer />
            </PageFocusItem>
          </FocusGrid>
        </ContainerGrid>
      </Box>
    </FormModal>
  );
}

CheckDepositHistory.propTypes = {
  handleClose: PropTypes.func
};
